import { Drawer, styled } from "@mui/material";
import { drawerWidth } from "../../../../consts/drawerWidth";
import { IStyledRootProps } from "./types";

const StyledRoot = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== "isFullscreen",
})<IStyledRootProps>(({theme, isFullscreen})=>({
    width: isFullscreen ? "100vw" : drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: isFullscreen ? "100vw" : drawerWidth,
        boxSizing: 'border-box',
        height: isFullscreen ? "100vh" : "100%",
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        right: 0,
        top: 0,
    },
}))

export {StyledRoot}